import React from 'react'
import { orderBy } from 'lodash'
import { useQuery } from '@apollo/client'
import { GetLocationProducts, GetLocationProductsVariables, SubLocation } from '../../types'
import { GET_LOCATION_PRODUCTS } from './operations'

export const useLocationTestProducts = ({ testLocationId, sublocation }: {
  testLocationId: string | null,
  sublocation?: SubLocation
}) => {
  const { data, loading: isProductsDataLoading } = useQuery<
    GetLocationProducts,
    GetLocationProductsVariables
  >(GET_LOCATION_PRODUCTS, {
    variables: {
      pagination: { from: 0, length: 100 },
      filterData: {
        locationId: testLocationId,
        ...(sublocation && { sublocation }),
      },
      pricefilterData: {
        locationId: testLocationId,
      },
    },
  })

  const products = React.useMemo(
    () =>
      (data?.products.products ?? []).map((product) => ({
        ...product,
        Prices: orderBy(product.Prices, ['minQuantity'], ['desc'])
          .filter((price) => sublocation ? price?.sublocation === sublocation : price),
      })),
    [data?.products.products]
  )

  return {
    products,
    isProductsDataLoading,
  }
}
